<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);


  let obj = listData
  let colorStop=[
    {
      start:'rgba(0, 142, 255, 0.1)',
      end:'rgba(0, 142, 255, 0.6)'
    },
    {
      start:'rgba(0, 242, 240,0.1)',
      end:'rgba(0, 242, 240,06)'
    },
    {
      start:'rgba(255, 219, 14,0.1)',
      end:'rgba(255, 219, 14, 0.6)'
    },
    {
      start:'rgba(102, 225, 223,0.02)',
      end:'rgba(102, 225, 223, 0.6)'
    },
    {
      start:'rgba(255, 173, 106,0.02)',
      end:'rgba(255, 173, 106, 0.6)'
    },
    {
      start:'rgba(255, 224, 171,0.02)',
      end:'rgba(255, 224, 171, 0.6)'
    },
    {
      start:'rgba(107, 197, 244,0.02)',
      end:'rgba(107, 197, 244, 0.6)'
    },
    {
      start:'rgba(192, 142, 242,0.02)',
      end:'rgba(192, 142, 242, 0.6)'
    },
  ]
  let serData = []
  obj.lineData.forEach((item,index) => {
    serData.push({
      name: item.name,
      type: "line",
      // stack: "all",
      showSymbol: true,
      symbolSize: 10,
      symbol: "circle",
      smooth:true,
      lineStyle: {},
      itemStyle: {
        borderWidth: 2,
      },
      // areaStyle: {
      //   color: {
      //     type: "linear",
      //     x: 0,
      //     y: 0,
      //     x2: 0,
      //     y2: 1,
      //     colorStops: [
      //       {
      //         offset: 0,
      //         color:colorStop[index]?colorStop[index].end:'rgba(0, 142, 255, 0.6)',
      //       },
      //       {
      //         offset: 1,
      //         color: colorStop[index]?colorStop[index].start:'rgba(0, 142, 255, 0.02)',
      //       },
      //     ],
      //     globalCoord: false, // 缺省为 false
      //   },
      // },
      data: item.data,
    })
  })

  const option= {
    color: [
      '#159AFF',
      '#66E193',
      '#E3F170',
      '#66E1DF',
      '#FFAD6A',
      '#ffe0ab',
      '#6bc5f4',
      '#c08ef2',
    ],
    legend: {
      icon: 'rect',
      top: '3%',
      //   left: 'center',
      orient: 'horizontal', //图例方向【horizontal/vertical】
      itemHeight: 6, //修改icon图形大小
      itemWidth: 16, //修改icon图形大小
      itemGap: 50,
      textStyle: {
        fontSize: 24,
        color: '#fff',
        padding: [0, 8],
      },
    },
    tooltip: {
      show: true,
      trigger: "axis",
      backgroundColor: "#0a2b45", // 设置背景颜色
      textStyle: {
        color: '#fff',
        fontSize: 26,
      },
      borderColor: "rgba(255, 255, 255, .16)",
      axisPointer: {
        lineStyle: {
          color: "rgba(28, 124, 196)",
        },
      },

      formatter: (params) => {
        let arr = [...params];
        let str = '';
        arr.forEach((item, index) => {
          str += item.marker + item.seriesName + '  ' + item.data + '<br />';
        });
        str = arr[0].name + '<br />' + str;
        return str;
      },
    },


    grid: {
      top: "18%",
      left: "3%",
      right: "2%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          onZero:true,
          lineStyle: {
            color: "#81b0d0",
          },
        },
        axisLabel: {
          interval:1,
          align: "center",
          margin: 10,
          color: "#fff",
          rotate: 0,
          textStyle: {
            fontSize: 24,
          },
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        boundaryGap: false,
        data:obj.xData,
      },
    ],

    yAxis:{
      type: "value",
      name: "（元/斤）",
      max:8,
      min:0,
      nameTextStyle: {
        //y轴上方单位的颜色
        color: "#fff",
        fontSize:24,
        padding:[0,0,20,0]
      },
      // splitNumber: 3,
      axisLine: {
        show: false,
        lineStyle: {
          color: "#81b0d0",
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "rgba(221, 228, 241,.2)",
          // type: "dashed",
        },
      },
      axisLabel: {
        color: "#fff",
        textStyle: {
          fontSize: 24,
          padding:[0,5,0,0]
        },
        formatter: function (value) {
          // 当值为 0 时不显示标签
          return value == 0 ? "" : value;
        },
      },
      axisTick: {
        show: false,
      },
    },
    series: serData,
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);
  console.log(serData)

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
